(function () {
  const money = new Intl.NumberFormat('zh-TW', {
    style: 'currency',
    currency: 'TWD',
    maximumFractionDigits: 0,
  });

  function unique(values) {
    return [...new Set(values)];
  }

  function optionMarkup(values) {
    return values.map((value) => `<option value="${String(value).replace(/"/g, '&quot;')}">${value}</option>`).join('');
  }

  function init(root) {
    if (root.dataset.hpReady === 'true') return;

    const dataElement = root.querySelector('[data-hp-bundle-data]');
    if (!dataElement) return;

    const data = JSON.parse(dataElement.textContent);
    const products = data.products.filter((entry) => entry.product && entry.product.id);
    if (products.length < 2) return;

    root.dataset.hpReady = 'true';
    const pairs = [...root.querySelectorAll('[data-hp-pair]')];
    const currentHandle = root.dataset.currentHandle;
    const currentIndex = Math.max(0, products.findIndex((entry) => entry.product.handle === currentHandle));

    pairs.forEach((pair, index) => {
      const modelSelect = pair.querySelector('[data-hp-model]');
      modelSelect.innerHTML = products
        .map((entry, productIndex) => `<option value="${productIndex}">${entry.product.title}</option>`)
        .join('');
      modelSelect.value = String(currentIndex);
      modelSelect.addEventListener('change', () => renderPair(pair, products));
      pair.querySelector('[data-hp-color]').addEventListener('change', () => renderSizes(pair, products));
      pair.querySelector('[data-hp-size]').addEventListener('change', () => update(root, products));
      renderPair(pair, products);
    });

    root.querySelector('[data-hp-add-bundle]').addEventListener('click', () => addBundle(root, products));
    update(root, products);
  }

  function selectedProduct(pair, products) {
    return products[Number(pair.querySelector('[data-hp-model]').value)];
  }

  function renderPair(pair, products) {
    const entry = selectedProduct(pair, products);
    const colors = unique(entry.product.variants.map((variant) => variant.options[0]));
    pair.querySelector('[data-hp-color]').innerHTML = optionMarkup(colors);
    renderSizes(pair, products);
  }

  function renderSizes(pair, products) {
    const entry = selectedProduct(pair, products);
    const color = pair.querySelector('[data-hp-color]').value;
    const sizes = unique(
      entry.product.variants
        .filter((variant) => variant.options[0] === color)
        .map((variant) => variant.options[1]),
    );
    pair.querySelector('[data-hp-size]').innerHTML = optionMarkup(sizes);
    update(pair.closest('[data-hp-bundle-builder]'), products);
  }

  function selectedVariant(pair, products) {
    const entry = selectedProduct(pair, products);
    const color = pair.querySelector('[data-hp-color]').value;
    const size = pair.querySelector('[data-hp-size]').value;
    const variant = entry.product.variants.find(
      (item) => item.options[0] === color && item.options[1] === size,
    );
    return {entry, variant, color, size};
  }

  function update(root, products) {
    const selections = [...root.querySelectorAll('[data-hp-pair]')].map((pair) => {
      const selection = selectedVariant(pair, products);
      const availability = pair.querySelector('[data-hp-availability]');
      // Every XLIPPER variant is configured with inventoryPolicy CONTINUE.
      // Shopify can nevertheless serialize `variant.available` as false while
      // viewing an unpublished preview theme, which incorrectly blocks every
      // mix-and-match combination. A matching variant ID is enough here; the
      // cart API remains the source of truth and will reject anything Shopify
      // genuinely cannot sell.
      const available = Boolean(selection.variant);
      availability.textContent = available ? '可選購' : '此組合目前無法購買';
      availability.classList.toggle('is-sold-out', !available);
      return selection;
    });

    const original = selections.reduce((sum, selection) => sum + Number(selection.variant?.price || 0), 0);
    const bundle = selections.reduce((sum, selection) => sum + selection.entry.targetPrice, 0);
    root.querySelector('[data-hp-original-price]').textContent = money.format(original / 100);
    root.querySelector('[data-hp-bundle-price]').textContent = money.format(bundle / 100);
    root.querySelector('[data-hp-savings]').textContent = `現省 ${money.format(Math.max(0, original - bundle) / 100)}`;
    root.querySelector('[data-hp-add-bundle]').disabled = selections.some(
      (selection) => !selection.variant,
    );
  }

  async function addBundle(root, products) {
    const button = root.querySelector('[data-hp-add-bundle]');
    const message = root.querySelector('[data-hp-message]');
    const selections = [...root.querySelectorAll('[data-hp-pair]')].map((pair) => selectedVariant(pair, products));

    if (selections.some((selection) => !selection.variant)) {
      message.textContent = '請重新選擇可購買的款式與尺寸。';
      return;
    }

    const bundleId = `hp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const pairName = selections.map((selection) => selection.entry.key).join(' + ');
    button.disabled = true;
    button.textContent = '加入中…';
    message.textContent = '';

    try {
      const items = selections.map((selection) => ({
        id: selection.variant.id,
        quantity: 1,
        properties: {
          _hp_bundle_id: bundleId,
          _hp_bundle_offer: 'xlipper-1plus1',
          '優惠方案': `XLIPPER 1+1 任選 · ${pairName}`,
        },
      }));
      // Variant IDs exceed JavaScript's safe-integer range. Keep them as
      // strings in memory, then write the exact digits into the JSON request so
      // Shopify receives an integer without browser-side rounding.
      const requestBody = `{"items":[${items.map((item) =>
        `{"id":${item.id},"quantity":${item.quantity},"properties":${JSON.stringify(item.properties)}}`,
      ).join(',')}]}`;
      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: requestBody,
      });
      const rawResult = await response.text();
      let result = {};
      try {
        result = JSON.parse(rawResult);
      } catch (_parseError) {
        result = {description: rawResult.slice(0, 180)};
      }
      if (!response.ok) {
        const details = result.description
          || result.message
          || (result.errors && JSON.stringify(result.errors))
          || `HTTP ${response.status}`;
        throw new Error(`${details} [${response.status}]`);
      }
      window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      message.textContent = error.message || '加入購物車失敗，請稍後再試。';
      button.disabled = false;
      button.textContent = '1+1 組合加入購物車';
    }
  }

  function initAll(container = document) {
    container.querySelectorAll('[data-hp-bundle-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
